export const LanguageItems = {
  English: { code: 'en', fullCode: 'en-US', native: 'English' },
  German: { code: 'de', fullCode: 'de-DE', native: 'Deutsch' },
  French: { code: 'fr', fullCode: 'fr-FR', native: 'Français' },
  Italian: { code: 'it', fullCode: 'it-IT', native: 'Italiano' },
  Portuguese: { code: 'pt', fullCode: 'pt-BR', native: 'Português' },
  Arabic: { code: 'ar', fullCode: 'ar-AR', native: 'العربية' },
} as const;

export enum LanguageItemsTranslations {
  English = 'en-US',
  German = 'de-DE',
  French = 'fr-FR',
  Italian = 'it-IT',
  Portuguese = 'pt-BR',
  Arabic = 'ar-AR',
}

export type LanguageItemsTranslationsType =
  | LanguageItemsTranslations.English
  | LanguageItemsTranslations.German
  | LanguageItemsTranslations.French
  | LanguageItemsTranslations.Italian
  | LanguageItemsTranslations.Portuguese
  | LanguageItemsTranslations.Arabic;
export type LanguageItemsType = keyof typeof LanguageItems;
export type LanguageCode = (typeof LanguageItems)[LanguageItemsType]['code'];
